<template>
  <div
    v-if="isPublicKeyEnabled"
    class="emd-panel__section"
  >
    <div class="eu-display_flex eu-column emd-panel__block">
      <emd-text
        tag="h2"
        size="section"
      >
        {{ $t('keys.public-key') }}
      </emd-text>

      <emd-text
        size="tiny"
        class="emd-text _color_nonessential eu-py_2"
      >
        {{ $t('keys.public-key-description') }}
      </emd-text>
    </div>

    <copy-clipboard
      class="emd-panel__block eu-basis_4_md eu-basis_2_lg"
      :copiable="publicKey"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { EmdText } from 'emerald-vue/src/components'

import { isPublicKeyEnabled } from '@/actions-permission/keys.permissions'

export default {
  name: 'PublicKey',

  components: {
    EmdText,

    CopyClipboard: () => import('@/components/project/molecules/CopyClipboard')
  },

  data () {
    return {
      publicKey: null
    }
  },

  computed: {
    ...mapGetters(['merchantId', 'accountId', 'permissionIsEnabled']),

    isPublicKeyEnabled () {
      return isPublicKeyEnabled(this.permissionIsEnabled)
    }
  },

  created () {
    this.getAccount()
  },

  methods: {
    ...mapActions(['GET_ACCOUNT']),

    getAccount () {
      const params = {
        merchantId: this.merchantId,
        accountId: this.accountId
      }

      this.GET_ACCOUNT(params).then(res => (this.publicKey = res.public_key))
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "keys": {
        "public-key": "Chave pública",
        "public-key-description": "Esta é sua chave para realizar testes na API. Ela não permite criar transações reais."
      }
    },
    "en-US": {
      "keys": {
        "public-key": "Public key",
        "public-key-description": "This key is used for API tests. It doesn't create real transactions."
      }
    }
  }
</i18n>
